import { render, staticRenderFns } from "./DataTableSimple.vue?vue&type=template&id=4048e548&scoped=true"
import script from "./DataTableSimple.vue?vue&type=script&lang=js"
export * from "./DataTableSimple.vue?vue&type=script&lang=js"
import style0 from "./DataTableSimple.vue?vue&type=style&index=0&id=4048e548&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4048e548",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4048e548')) {
      api.createRecord('4048e548', component.options)
    } else {
      api.reload('4048e548', component.options)
    }
    module.hot.accept("./DataTableSimple.vue?vue&type=template&id=4048e548&scoped=true", function () {
      api.rerender('4048e548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tables/DataTableSimple.vue"
export default component.exports